// TODO PendingToReceive: restore comment and delete actual fn when PendingToReceive EP is ready
export const hasPendingToReceiveOrders = pendingOrders => !!pendingOrders

export const LOGIREST_PROVIDER_ID = 1377121

export const isProviderLogirest = provider => {
  const iL = provider.id === LOGIREST_PROVIDER_ID
  return iL
}
